import { Component, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProvidersService } from '../../services/providers.service';
import { getDownloadURL, getStorage, ref, uploadBytes } from 'firebase/storage';
import { CameraService } from '../../../shared/image-uploader/camera/camera.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-admin-providers',
  standalone: false,
  templateUrl: './admin-providers.component.html',
  styleUrl: './admin-providers.component.scss'
})
export class AdminProvidersComponent implements OnInit {
  private readonly cameraService = inject(CameraService)
  
  private readonly fb = inject(FormBuilder);

  public readonly providersService = inject(ProvidersService);

  public previewUrl = signal<string | ArrayBuffer | null>(null);

  form = this.fb.group({
    name: this.fb.control('', [Validators.required]),
    address: this.fb.control('', [Validators.required]),
    bank_account_number: this.fb.control(null),
    bank_account_type: this.fb.control(null),
    bank_name: this.fb.control(null),
    rut: this.fb.control('', [Validators.required]),
    email: this.fb.control('', [Validators.required, Validators.email]),
    payment_method: this.fb.control(null),
    phone: this.fb.control('', [Validators.required]),
    picture: this.fb.control(null),
  });

  private readonly destroyRef = inject(DestroyRef);

  paymentMethod = this.form.get('payment_method').valueChanges;


  ngOnInit(): void {
    this.form.get('payment_method').valueChanges
      .pipe(
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe((value) => {
        if (value === 'bank_transfer') {
          this.form.get('bank_account_number').setValidators([Validators.required]);
          this.form.get('bank_account_type').setValidators([Validators.required]);
          this.form.get('bank_name').setValidators([Validators.required]);
        } else {
          this.form.get('bank_account_number').clearValidators();
          this.form.get('bank_account_type').clearValidators();
          this.form.get('bank_name').clearValidators();
        }
        this.form.get('bank_account_number').updateValueAndValidity();
        this.form.get('bank_account_type').updateValueAndValidity();
        this.form.get('bank_name').updateValueAndValidity();
      });
  }


  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) {
      return;
    }

    this.form.get('picture')?.setValue(file);

    const reader = new FileReader();
    reader.onload = () => {
      this.previewUrl.set(reader.result);
    };
    reader.readAsDataURL(file); 
  }

  onDialogClosed() {
    this.previewUrl.set(null);
  }
}
